import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "264",
  height: "107",
  viewBox: "0 0 264 107",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M144.674 50.8836C145.05 50.9674 145.124 51.5789 144.773 51.7382C137.998 54.04 132.666 59.9249 129.882 67.759C129.729 68.1388 129.061 68.0471 128.998 67.6418C128.045 61.4975 123.792 56.5917 118.313 55.268C117.95 55.1802 117.882 54.6109 118.22 54.4498C125.176 51.5931 130.404 45.7331 132.819 38.2463C132.97 37.8556 133.699 37.9543 133.761 38.3693C134.698 44.6361 139.065 49.6315 144.674 50.8836Z",
      fill: "var(--dt-color-foreground-muted)"
    }, null, -1)
  ]))]))
}
export default { render: render }